var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.768 10.106c.8-.947-.874-3.058-2.912-4.077-2.039-1.02-4.223-1.166-5.024-1.166-.8 0-1.383-1.02-1.237-2.038l.023-.164c.127-.933.217-1.588 1.87-1.656 1.747-.073 6.697.51 10.701 5.023 4.004 4.513 4.076 11.429 3.13 14.414-.946 2.985-4.295 7.28-7.571 8.809C19.47 30.782 17.869 31 16.487 31c-1.384 0-1.893-.946-1.893-1.747s.29-1.966 1.893-1.966c1.601 0 6.188-1.165 8.445-4.295 2.257-3.13 2.257-6.407 2.257-7.208 0-.8-1.093-1.82-1.675-1.747-.442.055-5.085.027-7.834.01-.87-.006-1.55-.01-1.848-.01-1.237 0-1.674 1.165-1.674 1.747 0 .583.51 2.039 1.674 2.039h6.917c-.293 1.48-2.55 4.504-4.734 4.586-3.858.145-8.517-.583-8.517-6.626-.001-6.042 4.148-6.916 6.332-6.916 2.138 0 2.95.349 3.94.773l.065.03c.815.349 1.407.824 1.601 1.018.714.073 2.18.059 2.33-.582zM10.227 6.61a1.82 1.82 0 1 0 0-3.639 1.82 1.82 0 0 0 0 3.641zM7.533 9.743a1.82 1.82 0 1 1-3.64 0 1.82 1.82 0 0 1 3.64 0zM3.82 17.677a1.82 1.82 0 1 0 0-3.64 1.82 1.82 0 0 0 0 3.64zm3.567 4.296a1.82 1.82 0 1 1-3.64 0 1.82 1.82 0 0 1 3.64 0zm2.84 7.207a1.82 1.82 0 1 0 0-3.64 1.82 1.82 0 0 0 0 3.64z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGo);
export default __webpack_public_path__ + "static/media/GO.fd980ffa420df574b164d6fc90a44e6b.svg";
export { ForwardRef as ReactComponent };